import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { circuitHistoryActions } from "../../../../../store/external/inventory/history/circuit-history.reducer";
import {TablePagination} from "../../../../common/details-table/table-pagination.component";

class CircuitHistory extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.getCircuitHistoryLogs(this.props.circuitId);
    }

    componentWillUnmount() {
        this.props.resetCircuitHistory();
    }

    getTableData(pageIndex) {
        this.props.getCircuitHistoryLogs(this.props.circuitId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeCircuitHistoryLogs, getCircuitHistoryLogs, circuitId } = this.props;
        resizeCircuitHistoryLogs(pageSize)
        getCircuitHistoryLogs(circuitId);
    }

    paginationAction = (pageIndex) => {
        const { getCircuitHistoryLogs, circuitId } = this.props;
        getCircuitHistoryLogs(circuitId, pageIndex);
    }

    onColumnSearch = () => {
        const { getCircuitHistoryLogs, circuitId } = this.props;
        getCircuitHistoryLogs(circuitId, 0);
    }

    render() {
        const { setCircuitHistoryColSearchStr } = this.props;
        const { IsLoadingTable } = this.props.inventoryCircuitHistory;
        const { 
        Headers = [], 
        Data = [], 
        Pagination = { TotalEntries: 0 } 
    } = this.props.inventoryCircuitHistory.HistoryTable;
        return (
            <>              
                <TablePagination  
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}                     
                    paginationAction={this.paginationAction}                   
                    onColumnSearch={() => { this.onColumnSearch() }}
                    onColumnSearchChange={setCircuitHistoryColSearchStr}
                    isColSearchShow={this.props.displaySearch}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={IsLoadingTable}                   
                />                
            </>
        );
    }
}

export default connect(
    state => {
        const { inventoryCircuitHistory } = state;

        return {
            inventoryCircuitHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, circuitHistoryActions),
        dispatch
    )
)(CircuitHistory);